<template>
  <div>
    <div class="answer-title">
      <span class="number">{{ data.index }}</span>
      <span class="type" v-if="questionType === 'SINGLE_CHOICE'"
        >【单选题】</span
      >
      <span class="type" v-else-if="questionType === 'MULTI_CHOICE'"
        >【多选题】</span
      >
      <span class="type" v-else>【判断题】</span>
      <div class="question-title" v-html="data.title"></div>
    </div>
    <div class="answer-content">
      <div class="answer-area">
        <!-- 已完成 -->
        <div class="done-answer" v-if="finished">
          <div v-for="item in data.options" :key="item.optionTitle">
            <div class="options-box finished">
              <img
                v-if="data.correctAnswer.indexOf(item.optionTitle) != -1"
                class="answer-status"
                src="../../assets/images/icons/icon-answer-right.png"
                alt=""
              />
              <img
                v-else
                class="answer-status"
                src="../../assets/images/icons/icon-answer-error.png"
                alt=""
              />
              <div class="question-options">
                <span>{{item.optionTitle + '.'}}</span>
                <div class="options" v-html="item.optionContent"></div>
              </div>
            </div>
          </div>
        </div>
        <!-- 单选/判断 -->
        <el-radio-group
          v-else-if="
            questionType === 'SINGLE_CHOICE' || questionType === 'JUDGE_CHOICE'
          "
          v-model="value"
          @change="changeRadio"
        >
          <el-radio
            class="options-box"
            :label="item.optionTitle"
            v-for="item in data.options"
            :key="item.optionTitle"
          >
            <div class="question-options">
              <span>{{item.optionTitle + '.'}}</span>
              <div class="options" v-html="item.optionContent"></div>
            </div>
          </el-radio>
        </el-radio-group>
        <!-- 多选 -->
        <el-checkbox-group v-else v-model="value" @change="changeCheck">
          <el-checkbox
            class="options-box"
            :label="item.optionTitle"
            v-for="item in data.options"
            :key="item.optionTitle"
          >
            <div class="question-options">
              <span>{{item.optionTitle + '.'}}</span>
              <div class="options" v-html="item.optionContent"></div>
            </div>
          </el-checkbox>
        </el-checkbox-group>
      </div>
      <Analysis
        v-if="finished === 1"
        :analysis="data.analysis"
        :myAnswer="data.myAnswer"
        :correctAnswer="data.correctAnswer"
      ></Analysis>
    </div>
  </div>
</template>

<script>
import Analysis from "./analysis";
export default {
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  components: {
    Analysis
  },
  data() {
    return {
      value: null
    };
  },
  computed: {
    answers() {
      return this.$store.state.questions.answers;
    },
    finished() {
      return this.$store.state.questions.finished;
    },
    isShowAnalysis() {
      return this.$store.state.questions.isShowAnalysis;
    },
    questionType() {
      return this.data.questionType;
    }
  },
  watch: {
    data(newVal) {
      newVal.myAnswer = (newVal.myAnswer) ? newVal.myAnswer : {}
      if (this.answers[newVal.questionMainId]) {
        if (newVal.questionType === "MULTI_CHOICE") {
          this.value = this.answers[newVal.questionMainId].answer.split("");
        } else {
          this.value = this.answers[newVal.questionMainId].answer;
        }
      } else {
        if (newVal.questionType === "MULTI_CHOICE") {
          this.value = [];
        } else {
          this.value = "";
        }
      }
      this.$store.dispatch("questions/colseAnalysis");
    }
  },
  methods: {
    changeRadio() {
      let obj = {
        id: this.data.questionMainId,
        answer: this.value
      };
      this.$store.dispatch("questions/addAnswer", obj);
      setTimeout(() => {
        this.$store.dispatch('questions/selectQuestion', 'down');
      }, 200)
      
    },
    changeCheck() {
      if (this.value.length === 0) {
        this.$store.dispatch(
          "questions/deleteAnswer",
          this.data.questionMainId
        );
      } else {
        let obj = {
          id: this.data.questionMainId,
          answer: this.value.join("")
        };
        this.$store.dispatch("questions/addAnswer", obj);
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../assets/css/style.scss";
.answer-title {
  padding: 30px;
  background-color: #f5f5f5;
  @include flex();
  .number {
    font-size: 20px;
    color: $answer-text-primary;
  }
  .number,
  .type {
    font-weight: bold;
    line-height: 24px;
    flex-shrink: 0;
  }

  .question-title,
  .type {
    font-size: 16px;
    color: $answer-text-primary;
  }
}
.answer-content {
  word-wrap: break-word;
  width: 100%;
  padding: 30px 0;
  .answer-area {
    padding: 0 50px;
  }
}
.options-box {
  @include flex();
  &.finished {
    .answer-status {
      margin: 1px 11px 0 0;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/questions/questionType.vue